import { zhCN } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { dark, light } from "./color";
import componentStyleOverrides from "./componentStyleOverrides";
import themePalette from "./palette";
import shadows from "./shadows";
import themeTypography from "./typography";
export var theme = function theme(_ref) {
  var mode = _ref.mode,
    colors = _ref.colors,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme;
  var color = colors ? colors[mode] : mode === 'light' ? light : dark;
  var themeOptions = {
    palette: themePalette(color, mode),
    shadows: shadows(color),
    typography: themeTypography(),
    components: componentStyleOverrides(color)
  };
  var themes = createTheme(deepmerge(themeOptions, theme), zhCN);
  return themes;
};
export default theme;